var _path, _g, _g2, _g3, _g4, _g5, _g6, _circle, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoGeneratedConnections = function SvgAutoGeneratedConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 155 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFC0C7",
    d: "M93.13 18.01a.25.25 0 0 0 0-.353l-1.59-1.59a.25.25 0 0 0-.354.353l1.414 1.414-1.414 1.414a.25.25 0 0 0 .354.354zm-56.759.074h2.02v-.5h-2.02zm6.063 0h4.041v-.5h-4.041zm8.083 0h4.041v-.5h-4.041zm8.083 0h4.042v-.5H58.6zm8.083 0h4.042v-.5h-4.042zm8.084 0h4.041v-.5h-4.041zm8.083 0h4.042v-.5H82.85zm8.083 0h2.021v-.5h-2.02z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__a)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 100.359,
    y: 3.925,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.455,
    cy: 8.175,
    r: 3.135,
    fill: "#D0DADB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.488,
    cy: 8.174,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m106.684 9.099 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.464-1.464-.95 1.785z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.7 8.192a.75.75 0 0 0 .205-.496c0-.272-.097-.49-.423-.49-.327 0-.424.218-.424.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.401c.006 0 .152 0 .121-.164-.084-.52-.343-.726-.603-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.457,
    cy: 7.736,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 113.59,
    y: 7.021,
    fill: "#EDEEF2",
    rx: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 100.09,
    y: 3.925,
    fill: "#FAFAFA",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.185,
    cy: 8.175,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.215,
    cy: 8.174,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m106.41 9.099 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.463-1.464-.95 1.785z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.426 8.192a.75.75 0 0 0 .206-.496c0-.272-.097-.49-.424-.49s-.423.218-.423.49c0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.401c.006 0 .151 0 .121-.164-.085-.52-.344-.726-.604-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.184,
    cy: 7.736,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 113.32,
    y: 7.021,
    fill: "#EDEEF2",
    rx: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 100.09,
    y: 13.425,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.185,
    cy: 17.675,
    r: 3.135,
    fill: "#89A2A5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.215,
    cy: 17.674,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m106.41 18.599 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.463-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.426 17.692a.75.75 0 0 0 .206-.496c0-.272-.097-.49-.424-.49s-.423.218-.423.49c0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.401c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.184,
    cy: 17.236,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 113.32,
    y: 16.521,
    fill: "#EDEEF2",
    rx: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 100.359,
    y: 22.925,
    fill: "#FAFAFA",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.455,
    cy: 27.175,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.488,
    cy: 27.174,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m106.684 28.099 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.464-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.7 27.192a.75.75 0 0 0 .205-.496c0-.272-.097-.49-.423-.49-.327 0-.424.218-.424.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.401c.006 0 .152 0 .121-.163-.084-.52-.343-.726-.603-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.457,
    cy: 26.736,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 113.59,
    y: 26.021,
    fill: "#EDEEF2",
    rx: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 10.929,
    x: 95.359,
    y: 17.77,
    fill: "#fff",
    rx: 1.286,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.479,
    cy: 23.233,
    r: 4.03,
    fill: "#1A2172"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.524,
    cy: 23.232,
    r: 2.411,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m103.492 24.422 1.407 1.19a2.42 2.42 0 0 0 1.913-1.602l-1.882-1.882-1.221 2.294z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M104.795 23.256a.97.97 0 0 0 .264-.638c0-.35-.124-.63-.544-.63s-.545.28-.545.63c0 .226.109.49.265.638-.335.078-.66.342-.777 1.01-.039.21.156.21.156.21h1.801c.008 0 .195 0 .156-.21-.109-.668-.442-.932-.776-1.01",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.484,
    cy: 22.669,
    r: 0.683,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.687,
    height: 2.967,
    x: 112.367,
    y: 21.75,
    fill: "#EDEEF2",
    rx: 1.286
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 10.929,
    x: 95.359,
    y: 5.888,
    fill: "#fff",
    rx: 1.286,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.479,
    cy: 11.352,
    r: 4.03,
    fill: "#FFB77C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.524,
    cy: 11.351,
    r: 2.411,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m103.492 12.541 1.407 1.19a2.42 2.42 0 0 0 1.913-1.602l-1.882-1.882-1.221 2.294z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M104.795 11.375a.97.97 0 0 0 .264-.638c0-.35-.124-.63-.544-.63s-.545.28-.545.63c0 .226.109.49.265.638-.335.078-.66.342-.777 1.01-.039.21.156.21.156.21h1.801c.008 0 .195 0 .156-.21-.109-.668-.442-.932-.776-1.01",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.484,
    cy: 10.789,
    r: 0.683,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.687,
    height: 2.967,
    x: 112.367,
    y: 9.869,
    fill: "#EDEEF2",
    rx: 1.286
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.353,
    cy: 17.516,
    r: 4.408,
    fill: "#0E72ED"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC0C7",
    clipPath: "url(#auto-generated-connections_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.908 16.983-.231.23a.253.253 0 1 1-.358-.358l.231-.23a.454.454 0 0 0 0-.642.464.464 0 0 0-.641 0l-.945.945a.45.45 0 0 0 0 .642.253.253 0 1 1-.358.358.95.95 0 0 1-.282-.68c0-.256.1-.497.282-.679l.945-.944a.96.96 0 0 1 1.357 1.358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.413 16.76a.253.253 0 0 0 0 .358.45.45 0 0 1 0 .642l-.945.945a.454.454 0 0 1-.642-.642l.232-.231a.255.255 0 0 0 0-.359.255.255 0 0 0-.359 0l-.231.232a.962.962 0 0 0 .679 1.638.96.96 0 0 0 .679-.28l.945-.945a.96.96 0 0 0 .281-.68c0-.256-.1-.497-.281-.678a.253.253 0 0 0-.358 0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 19,
    y: 9.425,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.096,
    cy: 13.675,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.129,
    cy: 13.674,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m25.324 14.599 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.463-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.34 13.692a.75.75 0 0 0 .206-.496c0-.272-.097-.49-.424-.49s-.423.218-.423.49c0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.12.164.12.164h1.402c.006 0 .151 0 .121-.164-.085-.52-.344-.726-.604-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.098,
    cy: 13.236,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 32.23,
    y: 12.521,
    fill: "#EDEEF2",
    rx: 1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__i)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 28.73,
    y: 4.425,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.826,
    cy: 8.675,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.855,
    cy: 8.674,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m35.05 9.599 1.095.925a1.88 1.88 0 0 0 1.488-1.246l-1.464-1.464-.95 1.785z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.067 8.692a.75.75 0 0 0 .205-.496c0-.272-.096-.49-.423-.49s-.423.218-.423.49c0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.402c.006 0 .15 0 .12-.164-.084-.52-.343-.726-.603-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.824,
    cy: 8.236,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 41.961,
    y: 7.521,
    fill: "#EDEEF2",
    rx: 1
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 18.73,
    y: 13.925,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.826,
    cy: 18.175,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.855,
    cy: 18.174,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m25.05 19.099 1.095.925a1.88 1.88 0 0 0 1.488-1.246l-1.464-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.067 18.192a.75.75 0 0 0 .205-.496c0-.272-.096-.49-.423-.49s-.423.218-.423.49c0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.402c.006 0 .15 0 .12-.163-.084-.52-.343-.726-.603-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.824,
    cy: 17.736,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 31.961,
    y: 17.021,
    fill: "#EDEEF2",
    rx: 1
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__k)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 24,
    y: 13.925,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.096,
    cy: 18.175,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.129,
    cy: 18.174,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m30.324 19.099 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.463-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M31.34 18.192a.75.75 0 0 0 .206-.496c0-.272-.097-.49-.424-.49s-.423.218-.423.49c0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.12.163.12.163h1.402c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.098,
    cy: 17.736,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 37.23,
    y: 17.021,
    fill: "#EDEEF2",
    rx: 1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__l)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 19,
    y: 23.425,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.096,
    cy: 27.675,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.129,
    cy: 27.674,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m25.324 28.599 1.094.925a1.88 1.88 0 0 0 1.488-1.246l-1.463-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.34 27.692a.75.75 0 0 0 .206-.496c0-.272-.097-.49-.424-.49s-.423.218-.423.49c0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.12.163.12.163h1.402c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.098,
    cy: 27.236,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 32.23,
    y: 26.521,
    fill: "#EDEEF2",
    rx: 1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#auto-generated-connections_svg__m)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8.5,
    x: 13.73,
    y: 18.425,
    fill: "#fff",
    rx: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.826,
    cy: 22.675,
    r: 3.135,
    fill: "#D4D7D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.855,
    cy: 22.674,
    r: 1.875,
    fill: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m20.05 23.599 1.095.925a1.88 1.88 0 0 0 1.488-1.246l-1.464-1.463-.95 1.784z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.067 22.692a.75.75 0 0 0 .205-.496c0-.272-.096-.49-.423-.49s-.423.218-.423.49c0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.402c.006 0 .15 0 .12-.163-.084-.52-.343-.726-.603-.786",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.824,
    cy: 22.236,
    r: 0.531,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.757,
    height: 2.307,
    x: 26.961,
    y: 21.521,
    fill: "#EDEEF2",
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__a",
    width: 37,
    height: 10.5,
    x: 99.859,
    y: 3.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__b",
    width: 37,
    height: 10.5,
    x: 99.59,
    y: 3.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__c",
    width: 37,
    height: 10.5,
    x: 99.59,
    y: 13.425,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__d",
    width: 37,
    height: 10.5,
    x: 99.859,
    y: 22.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__e",
    width: 47,
    height: 12.929,
    x: 94.859,
    y: 17.77,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__f",
    width: 47,
    height: 12.929,
    x: 94.859,
    y: 5.888,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__h",
    width: 39,
    height: 12.5,
    x: 18,
    y: 9.425,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__i",
    width: 39,
    height: 12.5,
    x: 27.73,
    y: 4.425,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__j",
    width: 39,
    height: 12.5,
    x: 17.73,
    y: 13.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__k",
    width: 39,
    height: 12.5,
    x: 23,
    y: 13.925,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__l",
    width: 39,
    height: 12.5,
    x: 18,
    y: 23.425,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "auto-generated-connections_svg__m",
    width: 39,
    height: 12.5,
    x: 12.73,
    y: 18.425,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4066_313789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4066_313789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "auto-generated-connections_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.188 15.344h4v4h-4z"
  })))));
};
export { SvgAutoGeneratedConnections as ReactComponent };
export default __webpack_public_path__ + "fonts/auto-generated-connections-4d303ce4a85b01c2b4e492c00c335f2d.svg";